export default "__VITE_PUBLIC_ASSET__23a3ce96__"